export class ApiError extends Error {
    status;
    detail;
    constructor(status, detail, message) {
        super(message);
        this.status = status;
        this.detail = detail;
    }
}
async function request(method, path, body) {
    const res = await fetch(`/api${path}`, {
        method,
        credentials: "include",
        headers: body ? { "Content-Type": "application/json" } : {},
        body: body ? JSON.stringify(body) : undefined,
    });
    if (res.status === 204)
        return undefined;
    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        // Non-JSON body (e.g. nginx "Internal Server Error" or HTML error
        // pages from upstream proxies). Keep the raw text so the user sees
        // *something* rather than an opaque JSON.parse exception.
        if (!res.ok) {
            throw new ApiError(res.status, text, text.slice(0, 200) || `request failed (${res.status})`);
        }
        return null;
    }
    if (!res.ok) {
        const detail = data?.detail ?? data;
        const msg = formatDetail(detail) ?? `request failed (${res.status})`;
        throw new ApiError(res.status, detail, msg);
    }
    return data;
}
function formatDetail(detail) {
    if (typeof detail === "string")
        return detail;
    if (Array.isArray(detail)) {
        // FastAPI 422 shape: [{loc: [...], msg, type, input?}]
        const parts = detail
            .slice(0, 5)
            .map((d) => {
            if (d && typeof d === "object") {
                const loc = Array.isArray(d.loc)
                    ? (d.loc).slice(1).join(".")
                    : "";
                const m = d.msg ?? "";
                return loc ? `${loc}: ${m}` : m;
            }
            return String(d);
        })
            .filter(Boolean);
        if (parts.length) {
            return parts.join(" · ") + (detail.length > 5 ? ` (+${detail.length - 5} more)` : "");
        }
    }
    return null;
}
async function upload(path, file, fields) {
    const fd = new FormData();
    fd.append("file", file);
    if (fields) {
        for (const [k, v] of Object.entries(fields)) {
            if (v !== undefined && v !== null && v !== "")
                fd.append(k, v);
        }
    }
    const res = await fetch(`/api${path}`, {
        method: "POST",
        credentials: "include",
        body: fd,
    });
    if (res.status === 204)
        return undefined;
    const text = await res.text();
    const data = text ? JSON.parse(text) : null;
    if (!res.ok) {
        const detail = data?.detail ?? data;
        const msg = typeof detail === "string" ? detail : `upload failed (${res.status})`;
        throw new ApiError(res.status, detail, msg);
    }
    return data;
}
export const api = {
    get: (path) => request("GET", path),
    post: (path, body) => request("POST", path, body),
    put: (path, body) => request("PUT", path, body),
    patch: (path, body) => request("PATCH", path, body),
    del: (path) => request("DELETE", path),
    upload: (path, file, fields) => upload(path, file, fields),
};
